import { render, staticRenderFns } from "./mainlayout.vue?vue&type=template&id=12ec1049&scoped=true&"
import script from "./mainlayout.vue?vue&type=script&lang=js&"
export * from "./mainlayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ec1049",
  null
  
)

export default component.exports